import React from 'react';
import { Card } from '../components/common/Card';
import { FlaskConical } from 'lucide-react';

export const TestingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-800 mb-2">
          Testing Interface
        </h1>
        <p className="text-slate-600 mb-8">
          Paste email content and test agent execution flows
        </p>

        <Card className="p-12 text-center">
          <FlaskConical size={64} className="mx-auto text-slate-300 mb-4" />
          <h2 className="text-2xl font-semibold text-slate-700 mb-2">
            Coming Soon
          </h2>
          <p className="text-slate-600">
            The testing interface will be implemented next. This will allow you to paste email
            content and test the agent execution flow without the Gmail Add-on.
          </p>
        </Card>
      </div>
    </div>
  );
};
